import { render, staticRenderFns } from "./merge_requests_list_app.vue?vue&type=template&id=2c570104"
import script from "./merge_requests_list_app.vue?vue&type=script&lang=js"
export * from "./merge_requests_list_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports